/*=========================================================================================
  File Name: moduleTypeState.js
  Description: Type Module State
  ----------------------------------------------------------------------------------------
==========================================================================================*/

export default {
  types: []
}
